import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { MoreHorizontal } from 'lucide-react';
import {
  IBucketListItem,
  BucketListContentType
} from '../../../../Models/bucket-list/bucket-list.model';

type Props = {
  item: IBucketListItem;
  onEdit: (item: IBucketListItem) => void;
  onRemove: (itemId: string) => void;
  onAddToTrip: (item: IBucketListItem) => void;
};

const CONTENT_TYPE_LABELS: Record<BucketListContentType, string> = {
  activity: 'Activity',
  research: 'Research',
  public_activity: 'Public Activity',
  raw_idea: 'Idea'
};

const CONTENT_TYPE_BADGE_CLASS: Record<BucketListContentType, string> = {
  activity: 'bg-primary',
  research: 'bg-info',
  public_activity: 'bg-success',
  raw_idea: 'bg-secondary'
};

const BucketListItemCard: React.FC<Props> = ({
  item,
  onEdit,
  onRemove,
  onAddToTrip
}) => {
  const badgeClass =
    CONTENT_TYPE_BADGE_CLASS[item.contentType] ?? 'bg-secondary';
  const typeLabel = CONTENT_TYPE_LABELS[item.contentType] ?? item.contentType;

  return (
    <div className='bl-item-card'>
      {/* Image with gradient overlay */}
      <div className='bl-item-card__image-wrapper'>
        {item.imageUrl ? (
          <img
            src={item.imageUrl}
            alt={item.title}
            className='bl-item-card__image'
          />
        ) : (
          <div className='bl-item-card__image-placeholder'>
            <span>🗺️</span>
          </div>
        )}
        <div className='bl-item-card__overlay'>
          <span className={`badge ${badgeClass} bl-content-type-badge`}>
            {typeLabel}
          </span>
          <h3 className='bl-item-card__title'>{item.title}</h3>
        </div>
      </div>

      {/* Footer */}
      <div className='bl-item-card__footer'>
        <div className='bl-item-card__meta'>
          {item.region && (
            <span className='bl-item-card__region'>{item.region}</span>
          )}
          {item.activityType && (
            <span className='bl-item-card__activity-type'>
              {item.region ? ' · ' : ''}
              {item.activityType}
            </span>
          )}
        </div>
        <Dropdown onClick={(e: React.MouseEvent) => e.stopPropagation()}>
          <Dropdown.Toggle
            variant='link'
            className='bl-item-card__menu-btn'
            id={`bl-item-menu-${item.id}`}
          >
            <MoreHorizontal size={16} />
          </Dropdown.Toggle>
          <Dropdown.Menu align='end'>
            <Dropdown.Item onClick={() => onEdit(item)}>Edit</Dropdown.Item>
            <Dropdown.Item onClick={() => onAddToTrip(item)}>
              Add to Trip
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item
              className='text-danger'
              onClick={() => onRemove(item.id)}
            >
              Remove
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {item.notes && <div className='bl-item-card__notes'>{item.notes}</div>}
    </div>
  );
};

export default BucketListItemCard;
